﻿import buttonLoader from '../utilities/buttonLoader.js';

var forgotPassword = {};

forgotPassword = {

  init: function () {
    var me = this;
    var loginForm = document.getElementsByClassName('forgotPassword__form')[0];

    if (loginForm) {
        me.bind(loginForm);
    }

  },

  bind: function (form) {
      var me = this;

      form.addEventListener('submit', function (e) {

          e.preventDefault();

          var m = form.querySelector('.alert');

          if (m) {
              m.remove();
          }

          me.submit(form);

      });
  },

  submit: function (form) {
      var me = this;

      var button = form.querySelector('button[type=submit]');

      buttonLoader.start(button);

      var data = new FormData(form);

      var xhr = new XMLHttpRequest();
      xhr.open(form.getAttribute("method"), form.getAttribute("action"));

      xhr.onload = function () {

          var resp = JSON.parse(xhr.response);

          if (xhr.status >= 200 && xhr.status < 300) {

              if (resp.success) {

                form.reset();

                buttonLoader.success(button);

                me.renderMessage(button, resp.message, 'success');

              } else {

                  buttonLoader.reset(button);

                  me.renderMessage(button, resp.message, 'error');
              }

          } else {

              buttonLoader.reset(button);

              me.renderMessage(button, 'Server error', 'error');
          }

      };

      xhr.send(data);
  },

  renderMessage: function (el, message, type) {
      el.insertAdjacentHTML('afterend', '<div class="alert ' + type + '">' + message + '</div>');

  }

};

forgotPassword.initialize = function () {
  forgotPassword.init();
};

module.exports = forgotPassword;
